import React from "react";

import close from "../../assets/close.svg";
import { theme } from "../../theme";

type props = {
  size?: number;
  onClick?: () => void;
  color?: string;
  className?: string;
  view?: string;
  selectView?: "selectAll" | "unselect" | null;
};

export const EmailIcon: React.FC<props> = ({ size = 26.5, ...props }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9026 8.85107L13.4593 12.4641C12.6198 13.1301 11.4387 13.1301 10.5992 12.4641L6.11842 8.85107"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9026 8.85107L13.4593 12.4641C12.6198 13.1301 11.4387 13.1301 10.5992 12.4641L6.11842 8.85107"
        stroke="#374146"
        strokeOpacity="0.6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9089 21C19.9502 21.0084 22 18.5095 22 15.4384V8.57001C22 5.49883 19.9502 3 16.9089 3H7.09114C4.04979 3 2 5.49883 2 8.57001V15.4384C2 18.5095 4.04979 21.0084 7.09114 21H16.9089Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9089 21C19.9502 21.0084 22 18.5095 22 15.4384V8.57001C22 5.49883 19.9502 3 16.9089 3H7.09114C4.04979 3 2 5.49883 2 8.57001V15.4384C2 18.5095 4.04979 21.0084 7.09114 21H16.9089Z"
        stroke="#374146"
        strokeOpacity="0.6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PasswordIcon: React.FC<props> = ({ size = 26.5, ...props }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4234 9.4478V7.3008C16.4234 4.7878 14.3854 2.7498 11.8724 2.7498C9.3594 2.7388 7.3134 4.7668 7.3024 7.2808V7.3008V9.4478"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4234 9.4478V7.3008C16.4234 4.7878 14.3854 2.7498 11.8724 2.7498C9.3594 2.7388 7.3134 4.7668 7.3024 7.2808V7.3008V9.4478"
        stroke="#374146"
        strokeOpacity="0.6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6832 21.2497H8.0422C5.9482 21.2497 4.2502 19.5527 4.2502 17.4577V13.1687C4.2502 11.0737 5.9482 9.37671 8.0422 9.37671H15.6832C17.7772 9.37671 19.4752 11.0737 19.4752 13.1687V17.4577C19.4752 19.5527 17.7772 21.2497 15.6832 21.2497Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6832 21.2497H8.0422C5.9482 21.2497 4.2502 19.5527 4.2502 17.4577V13.1687C4.2502 11.0737 5.9482 9.37671 8.0422 9.37671H15.6832C17.7772 9.37671 19.4752 11.0737 19.4752 13.1687V17.4577C19.4752 19.5527 17.7772 21.2497 15.6832 21.2497Z"
        stroke="#374146"
        strokeOpacity="0.6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8629 14.2026V16.4236"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8629 14.2026V16.4236"
        stroke="#374146"
        strokeOpacity="0.6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const HideIcon: React.FC<props> = ({ size = 26.5, ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_807_10362)">
        <path
          d="M6.59999 2.82676C7.05888 2.71935 7.5287 2.66566 7.99999 2.66676C12.6667 2.66676 15.3333 8.0001 15.3333 8.0001C14.9286 8.75717 14.446 9.46992 13.8933 10.1268M9.41332 9.41343C9.23022 9.60993 9.00942 9.76754 8.76409 9.87685C8.51876 9.98616 8.25392 10.0449 7.98538 10.0497C7.71684 10.0544 7.4501 10.005 7.20106 9.90443C6.95203 9.80384 6.7258 9.65412 6.53589 9.4642C6.34597 9.27428 6.19625 9.04806 6.09566 8.79902C5.99507 8.54999 5.94567 8.28325 5.95041 8.0147C5.95515 7.74616 6.01393 7.48133 6.12324 7.236C6.23255 6.99067 6.39016 6.76986 6.58666 6.58677M11.96 11.9601C10.8204 12.8288 9.43273 13.31 7.99999 13.3334C3.33332 13.3334 0.666656 8.0001 0.666656 8.0001C1.49592 6.4547 2.64608 5.1045 4.03999 4.0401L11.96 11.9601Z"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.59999 2.82676C7.05888 2.71935 7.5287 2.66566 7.99999 2.66676C12.6667 2.66676 15.3333 8.0001 15.3333 8.0001C14.9286 8.75717 14.446 9.46992 13.8933 10.1268M9.41332 9.41343C9.23022 9.60993 9.00942 9.76754 8.76409 9.87685C8.51876 9.98616 8.25392 10.0449 7.98538 10.0497C7.71684 10.0544 7.4501 10.005 7.20106 9.90443C6.95203 9.80384 6.7258 9.65412 6.53589 9.4642C6.34597 9.27428 6.19625 9.04806 6.09566 8.79902C5.99507 8.54999 5.94567 8.28325 5.95041 8.0147C5.95515 7.74616 6.01393 7.48133 6.12324 7.236C6.23255 6.99067 6.39016 6.76986 6.58666 6.58677M11.96 11.9601C10.8204 12.8288 9.43273 13.31 7.99999 13.3334C3.33332 13.3334 0.666656 8.0001 0.666656 8.0001C1.49592 6.4547 2.64608 5.1045 4.03999 4.0401L11.96 11.9601Z"
          stroke="#374146"
          strokeOpacity="0.6"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.666656 0.666748L15.3333 15.3334"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.666656 0.666748L15.3333 15.3334"
          stroke="#374146"
          strokeOpacity="0.6"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_807_10362">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const HomePageDiamondIcon: React.FC<props> = ({
  size = 26.5,
  ...props
}) => {
  return (
    <svg
      {...props}
      width="63"
      height="60"
      viewBox="0 0 72 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.5 33.3738V58.2809C33.5024 58.6144 33.4044 58.9414 33.2181 59.2213C33.0318 59.5012 32.7653 59.7219 32.4516 59.856C32.1379 59.9901 31.7907 60.0318 31.4529 59.976C31.1151 59.9201 30.8015 59.7692 30.5509 59.5417L2.39537 34.6541C2.13526 34.4172 1.95443 34.1096 1.87641 33.7714C1.7984 33.4331 1.82682 33.0797 1.95798 32.7574C2.08914 32.435 2.31695 32.1586 2.61176 31.9641C2.90657 31.7696 3.25471 31.666 3.61086 31.6668H31.7465C32.2099 31.6718 32.6529 31.8533 32.9806 32.1723C33.3084 32.4913 33.4948 32.9226 33.5 33.3738Z"
        fill="#FF154D"
      />
      <path
        d="M33.4198 23.1667C33.4146 23.6512 33.2269 24.1144 32.897 24.457C32.567 24.7997 32.121 24.9946 31.6545 25H3.57039C3.25085 24.9947 2.93869 24.8994 2.66721 24.7243C2.39573 24.5492 2.17512 24.3008 2.02892 24.0056C1.88271 23.7105 1.81639 23.3797 1.83703 23.0485C1.85767 22.7173 1.9645 22.3981 2.14613 22.125L14.3828 0.770831C14.5434 0.533294 14.7566 0.3393 15.0044 0.205159C15.2523 0.0710185 15.5275 0.000657479 15.807 0H31.7347C32.2013 0.00541447 32.6473 0.200309 32.9772 0.542959C33.3071 0.885609 33.4948 1.34879 33.5 1.83334L33.4198 23.1667Z"
        fill="#FF154D"
      />
      <path
        d="M40.1667 33.3738V58.2809C40.1643 58.6144 40.2623 58.9414 40.4486 59.2213C40.6349 59.5012 40.9013 59.7219 41.2151 59.856C41.5288 59.9901 41.876 60.0318 42.2138 59.976C42.5516 59.9201 42.8651 59.7692 43.1158 59.5417L71.2713 34.6541C71.5314 34.4172 71.7122 34.1096 71.7903 33.7714C71.8683 33.4331 71.8399 33.0797 71.7087 32.7574C71.5775 32.435 71.3497 32.1586 71.0549 31.9641C70.7601 31.7696 70.412 31.666 70.0558 31.6668H41.9202C41.4568 31.6718 41.0138 31.8533 40.686 32.1723C40.3583 32.4913 40.1719 32.9226 40.1667 33.3738Z"
        fill="#FF154D"
      />
      <path
        d="M40.1667 23.1667C40.1719 23.6512 40.36 24.1144 40.6908 24.457C41.0216 24.7997 41.4687 24.9946 41.9364 25H70.0919C70.4122 24.9947 70.7252 24.8994 70.9973 24.7243C71.2695 24.5492 71.4907 24.3008 71.6373 24.0056C71.7838 23.7105 71.8503 23.3797 71.8296 23.0485C71.8089 22.7173 71.7018 22.3981 71.5198 22.125L59.252 0.770831C59.091 0.533294 58.8773 0.3393 58.6288 0.205159C58.3803 0.0710185 58.1043 0.000657479 57.8241 0H41.9364C41.4687 0.00541447 41.0216 0.200309 40.6908 0.542959C40.36 0.885609 40.1719 1.34879 40.1667 1.83334V23.1667Z"
        fill="#FF154D"
      />
    </svg>
  );
};
export const DiamondIcon: React.FC<props> = ({ size = 26.5, ...props }) => {
  return (
    <svg
      {...props}
      width="27"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.859 13.33v9.066c0 .122-.033.24-.097.343a.607.607 0 0 1-.263.23.583.583 0 0 1-.652-.114L.193 13.797a.648.648 0 0 1-.15-.69.625.625 0 0 1 .224-.29.594.594 0 0 1 .343-.108h9.647c.16.002.311.068.424.184a.639.639 0 0 1 .178.438ZM10.858 7.851a.639.639 0 0 1-.178.438.598.598 0 0 1-.423.184H.691a.587.587 0 0 1-.307-.094.614.614 0 0 1-.218-.243.639.639 0 0 1 .04-.638L4.374.261A.58.58 0 0 1 4.86 0h5.425c.16.002.311.068.424.184a.639.639 0 0 1 .178.437l-.028 7.23ZM15.642 13.33v9.066c-.001.122.032.24.096.343a.607.607 0 0 0 .263.23.583.583 0 0 0 .652-.114l9.655-9.058a.648.648 0 0 0 .15-.69.625.625 0 0 0-.225-.29.594.594 0 0 0-.342-.108h-9.648a.598.598 0 0 0-.423.184.639.639 0 0 0-.178.438ZM15.642 7.851a.639.639 0 0 0 .178.438.599.599 0 0 0 .423.184h9.566a.587.587 0 0 0 .307-.094.614.614 0 0 0 .218-.243.64.64 0 0 0-.04-.638L22.126.261A.58.58 0 0 0 21.64 0h-5.398a.599.599 0 0 0-.423.184.639.639 0 0 0-.178.437v7.23Z"
        fill={theme.primary}
      />
    </svg>
  );
};

export const ArrowRight: React.FC<props> = () => {
  return (
    <svg
      width="22"
      height="13"
      viewBox="0 0 22 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9776 6.67627L11.9776 0.902767V12.4498L21.9776 6.67627ZM0.19043 7.67627H12.9776V5.67627H0.19043V7.67627Z"
        fill="#A9B6C3"
      />
    </svg>
  );
};

export const BurgerIcon: React.FC<props> = ({ size = 26.5, ...props }) => {
  return (
    <svg
      width={size}
      viewBox="0 0 40 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.48779 20C2.48779 18.6193 3.62187 17.5 5.02083 17.5L34.784 17.5C36.183 17.5 37.3171 18.6193 37.3171 20C37.3171 21.3807 36.183 22.5 34.784 22.5L5.02083 22.5C3.62187 22.5 2.48779 21.3807 2.48779 20Z"
        fill="#FF154D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4293 27.5C14.4293 26.1193 15.5825 25 17.0049 25L22.8001 25C24.2225 25 25.3757 26.1193 25.3757 27.5C25.3757 28.8807 24.2225 30 22.8001 30L17.0049 30C15.5825 30 14.4293 28.8807 14.4293 27.5Z"
        fill="#FF154D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.3171 12C37.3171 13.3807 36.1831 14.5 34.7841 14.5L5.0209 14.5C3.62194 14.5 2.48786 13.3807 2.48786 12C2.48786 10.6193 3.62194 9.5 5.0209 9.5L34.7841 9.5C36.1831 9.5 37.3171 10.6193 37.3171 12Z"
        fill="#FF154D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.3414 4.5C32.3414 5.88071 31.1924 7 29.7751 7L10.5273 7C9.10994 7 7.96094 5.88071 7.96094 4.5C7.96094 3.11929 9.10994 2 10.5273 2L29.7751 2C31.1924 2 32.3414 3.11929 32.3414 4.5Z"
        fill="#FF154D"
      />
    </svg>
  );
};

export const SearchIcon: React.FC<props> = ({ size = 15, ...props }) => {
  const { color = "white" } = props;
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.77781 12.5556C9.96881 12.5556 12.5556 9.96881 12.5556 6.77781C12.5556 3.58681 9.96881 1 6.77781 1C3.58681 1 1 3.58681 1 6.77781C1 9.96881 3.58681 12.5556 6.77781 12.5556Z"
        stroke={color}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.77781 12.5556C9.96881 12.5556 12.5556 9.96881 12.5556 6.77781C12.5556 3.58681 9.96881 1 6.77781 1C3.58681 1 1 3.58681 1 6.77781C1 9.96881 3.58681 12.5556 6.77781 12.5556Z"
        stroke={color}
        strokeOpacity="0.6"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9998 14L10.8582 10.8583"
        stroke={color}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9998 14L10.8582 10.8583"
        stroke={color}
        strokeOpacity="0.6"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SuccessCheck: React.FC<props> = ({ size = 15, ...props }) => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.87793 6C0.87793 4.63407 0.912441 3.61416 1.04086 2.84099C1.1687 2.0713 1.38009 1.60994 1.68398 1.30605C1.98787 1.00216 2.44923 0.79077 3.21892 0.66293C3.99209 0.534512 5.012 0.5 6.37793 0.5C7.74386 0.5 8.76377 0.534512 9.53694 0.66293C10.3066 0.79077 10.768 1.00216 11.0719 1.30605C11.3758 1.60994 11.5872 2.0713 11.715 2.84099C11.8434 3.61416 11.8779 4.63407 11.8779 6C11.8779 7.36593 11.8434 8.38584 11.715 9.15901C11.5872 9.9287 11.3758 10.3901 11.0719 10.6939C10.768 10.9978 10.3066 11.2092 9.53694 11.3371C8.76377 11.4655 7.74386 11.5 6.37793 11.5C5.012 11.5 3.99209 11.4655 3.21892 11.3371C2.44923 11.2092 1.98787 10.9978 1.68398 10.6939C1.38009 10.3901 1.1687 9.9287 1.04086 9.15901C0.912441 8.38584 0.87793 7.36593 0.87793 6Z"
        stroke="#29A0B1"
      />
      <path
        d="M4 5.33335L6 7.33335L12.6667 0.666687"
        stroke="#29A0B1"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FailCheck: React.FC<props> = ({ size = 15, ...props }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 9 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 3.99994L8 7.99994"
        stroke="#FF000F"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 3.99994L4 7.99994"
        stroke="#FF000F"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NewProjectIcon: React.FC<props> = ({ size = 18, ...props }) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.41602 16.7725C10.4785 17.8141 11.7389 18.335 13.1973 18.335C14.6556 18.335 15.9056 17.8141 16.9473 16.7725C18.0098 15.71 18.541 14.4495 18.541 12.9912C18.541 11.5329 18.0098 10.2829 16.9473 9.24121C15.9056 8.17871 14.6556 7.64746 13.1973 7.64746C11.7389 7.64746 10.4785 8.17871 9.41602 9.24121C8.37435 10.2829 7.85352 11.5329 7.85352 12.9912C7.85352 14.4495 8.37435 15.71 9.41602 16.7725ZM8.47852 8.30371C9.79102 6.99121 11.3639 6.33496 13.1973 6.33496C15.0306 6.33496 16.5931 6.99121 17.8848 8.30371C19.1973 9.59538 19.8535 11.1579 19.8535 12.9912C19.8535 14.8245 19.1973 16.3975 17.8848 17.71C16.5931 19.0016 15.0306 19.6475 13.1973 19.6475C11.3639 19.6475 9.79102 19.0016 8.47852 17.71C7.18685 16.3975 6.54102 14.8245 6.54102 12.9912C6.54102 11.1579 7.18685 9.59538 8.47852 8.30371ZM13.8535 9.64746V12.335H16.541V13.6475H13.8535V16.335H12.541V13.6475H9.85352V12.335H12.541V9.64746H13.8535Z"
        fill="white"
      />
    </svg>
  );
};

// export const DownloadIcon: React.FC<props> = ({ ...props }) => {
//   return (
//     <svg
//       {...props}
//       width="16"
//       height="16"
//       xmlns="http://www.w3.org/2000/svg"
//       fill="none"
//       viewBox="0 0 24 24"
//       stroke="currentColor"
//       strokeWidth={2}
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
//       />
//     </svg>
//   );
// };

export const PlaygroundIcon: React.FC<props> = ({ size = 16, ...props }) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)" fill="currentColor">
        <path d="M14.3898 10.8c.1627-.1101.2772-.2782.32-.47.0413-.1913.0092-.39124-.09-.56-.1008-.17111-.261-.29922-.45-.36-1.74-.61-4.48002-1.55-4.78002-1.6-.17051.0041-.33525.06258-.47018.16692-.13492.10435-.23297.24908-.27982.41308-.05486.15872-.05486.33127 0 .49.06377.16296.17984.30014.33.39l4.91002 1.7c.185.0074.3664-.0531.51-.17ZM13.6297 14.86c.1493.0496.3107.0496.46 0l-1.21-.36-.13-1.56c-1.53-.49-3.19002-1-3.40002-1-.18824.0046-.36883.0754-.51.2-.14304.1265-.23541.3006-.26.49-.01436.0926-.01026.187.01205.278.02231.091.0624.1766.11795.252.10865.1618.27197.2789.46.33l4.46002 1.37ZM9.58004 11.14c.19 0 1.47996.39 3.83996 1.14l.88-.57H13.89l-3.6-1.24-1.49996.87c.24262-.1313.51414-.2.79-.2ZM12.4697 8.00001l1.06-.68h-3.06l2 .68Z" />
        <path d="M14.8503 4.82002c-.2438-.2367-.5701-.36937-.91-.37H7.41032v-.21c.03594.01028.07405.01028.11 0 .03085-.01901.05525-.04689.07-.08.00743-.01738.01125-.03609.01125-.055 0-.0189-.00382-.03761-.01125-.055.01144-.03235.01144-.06764 0-.1l-1.71-1.9-1.89-1.9999969c-.01895-.0220792-.04297-.0392357-.07-.04999993h-.09c-.02572-.01004067-.05428-.01004067-.08 0-.02703.01076423-.05105.02792073-.07.04999993l-1.89 1.9999969-1.7400022 1.87c-.0073341.03293-.0073341.06707 0 .1-.0074271.01739-.0112553.0361-.0112553.055 0 .01891.0038282.03762.0112553.055.0057987.02001.0159891.03847.029829.05404.0138399.01557.0309802.02786.0501712.03596.017385.00743.036095.01126.055.01126.018905 0 .037615-.00383.055-.01126h.119999v3.1c.001393.04776.019031.09362.050001.13.041986.01529.088014.01529.13 0h.11v1.36h-.18c-.0481-.00039-.094557.01748-.129999.05-.030971.03639-.048609.08224-.050001.13v.7c-.005521.02301-.005521.047 0 .07v.06H.530317V11.32H.470318c-.024018-.0014-.048074.0022-.070574.0107-.0225.0086-.042933.0218-.059948.0388-.017015.017-.030224.0374-.038753.06-.00853.0225-.012185.0465-.010725.0705v.7c.001392.0478.01903.0936.050001.13.043156.0121.089202.0086.129999-.01h.11v1.36h-.11c-.045074.0077-.086853.0285-.120001.06-.014476.0421-.014476.0879 0 .13v.69c-.009097.0205-.013798.0426-.013798.065 0 .0224.004701.0446.013798.065.012875.0205.030514.0376.051409.0498.020895.0121.044428.0191.068592.0202h.129999v.3c-.004679.0197-.004679.0403 0 .06-.002872.0199-.002872.0401 0 .06h.970003c.00287-.0199.00287-.0401 0-.06.00468-.0197.00468-.0403 0-.06v-.3h4.25v.42h.99c.00287-.0199.00287-.0401 0-.06.00468-.0197.00468-.0403 0-.06v-.32h.17c.0481.0004.09456-.0175.13-.05.01836-.0164.03316-.0364.04348-.0588.01032-.0223.01594-.0466.01652-.0712v-.68c-.00058-.0246-.0062-.0488-.01652-.0712-.01032-.0224-.02512-.0424-.04348-.0588-.03544-.0325-.0819-.0504-.13-.05h-.17v-1.33h.17c.04888-.0044.09465-.0259.12936-.0606.03471-.0347.05617-.0805.06064-.1294v-.7c-.00072-.0231-.00646-.0459-.01682-.0666-.01036-.0207-.02509-.0389-.04318-.0534-.01552-.0194-.03535-.0349-.05792-.0453-.02256-.0104-.04724-.0155-.07208-.0147h-.17V9.94002h.31v-.06c.00328-.02321.00328-.04678 0-.07v-.7c.00078-.02484-.00423-.04952-.01465-.07208-.01041-.02257-.02594-.0424-.04535-.05792-.02028-.00975-.0425-.01481-.065-.01481-.02251 0-.04472.00506-.065.01481h-.17v-1.47h.17c.04198.01529.08801.01529.13 0 .01941-.01552.03494-.03535.04535-.05791.01042-.02257.01543-.04725.01465-.07209v-.36h6.52998c.1687.00185.336-.02992.4922-.09345.1563-.06353.2983-.15754.4178-.27655.1202-.11494.2159-.25308.2812-.40606.0653-.15297.0989-.3176.0988-.48394.092-.31325.0597-.64988-.09-.94Zm-10.65998-2.09c-.00702-.01216-.01072-.02595-.01072-.04 0-.01404.0037-.02784.01072-.04.0109-.0053.02287-.00806.035-.00806.01212 0 .02409.00276.035.00806h1.06l.75 1.26c.00468.01973.00468.04028 0 .06h-1.81v-1.24h-.07Zm-2.72 1.24c-.00434-.01976-.00434-.04023 0-.06l.76-1.26h1.07c.02257-.00843.04743-.00843.07 0 .00568.02637.00568.05364 0 .08v1.25h-1.9v-.01Zm0 1V4.85002h1.82c.02572-.01004.05428-.01004.08 0 .00467.01108.00708.02298.00708.035 0 .01203-.00241.02393-.00708.035v1.5c.00433.01977.00433.04024 0 .06-.0164.00424-.0336.00424-.05 0h-.06l-1.79-1.51Zm4.47 8.76998h-4.23v-1.42h4.25l-.02 1.42Zm0-2.42h-4.23V9.93002h4.25l-.02 1.38998Zm0-2.42998h-4.23v-1.39h4.25l-.02 1.39Zm.21-3.92-1.68 1.53h-.12c-.00468-.01972-.00468-.04027 0-.06v-1.62h1.86c.00615.0161.00615.0339 0 .05.00552.02301.00552.047 0 .07-.0132.0027-.0268.0027-.04 0l-.02.03Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="currentColor" d="M0 0h15.23v15.26H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlatformIcon: React.FC<props> = ({ size = 16, ...props }) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m12.5699 12.85-4.37001 1c-.07631.0104-.15369.0104-.23 0h-.2l-4.34-.85-2.890002.71c-.043775.0096-.082738.0344-.11.07-.008611.0294-.008611.0606 0 .09-.010684.0325-.010684.0675 0 .1.010686.0299.027745.0572.05.08.025123.0242.056151.0414.09.05l7.300002 1.46h.23l7.39001-1.78.08-.05c.028-.0196.049-.0476.06-.08.0049-.0332.0049-.0669 0-.1.0054-.0298.0054-.0603 0-.09-.0309-.0363-.0732-.061-.12-.07l-2.94-.54Z"
        fill="currentColor"
      />
      <path
        d="m12.5699 12.34 2.91-.71c.0438-.0096.0827-.0344.11-.07.0087-.0395.0087-.0805 0-.12.0097-.0394.0097-.0806 0-.12-.0297-.0377-.0726-.0627-.12-.07l-2.9-.58-3.80001.93-.59.08h-.44l-.51-.11-3.8-.74-2.890004.71c-.022222.0033-.043502.0112-.062454.0233-.018953.012-.035153.0279-.047546.0467-.014587.0387-.014587.0813 0 .12-.011672.0391-.011672.0808 0 .12.003939.0323.016125.0631.035388.0894.019263.0262.044956.0471.074612.0606l2.890004.59 1.17.23 3.25.67h.23l3.32001-.81 1.17-.34Z"
        fill="currentColor"
      />
      <path
        d="m8.08943 11.23 3.28997-.79 1.19-.28 2.9-.70002h.06c.0165.00351.0336.00351.05 0 .0086-.02938.0086-.06062 0-.09.0107-.03248.0107-.06752 0-.1.0049-.02644.0049-.05356 0-.08-.0296-.00684-.0604-.00684-.09 0l-3.89-.89-1.46 1.38-.44997.42002-.06.06c-.06582.0643-.14419.1143-.23021.147-.08603.0327-.17786.0473-.26979.043-.15476.0014-.30575-.0477-.43-.14-.12521-.0912-.21665-.22132-.26-.37002a.67023494.67023494 0 0 1 0-.24v-2l-.32-.06h-.12l-.4.1v1.95c.02003.09226.02003.18774 0 .28-.05781.13552-.15108.25302-.27.34002-.12078.0829-.26347.1282-.41.13-.1778-.0028-.34848-.0703-.48-.19l-.44-.40002-1.45-1.33-3.999997 1c-.031042.0178-.058235.04159-.08.07-.010025.03258-.010025.06742 0 .1-.009001.03949-.009001.0805 0 .12.02973.03764.072598.06265.12.07L3.47943 10.36l1.17.22 3.26.66h.23l-.05-.01Z"
        fill="currentColor"
      />
      <path
        d="M2.85006 5.63995c-.05078.00143-.0998.01894-.14.05-.04086.02625-.07236.06476-.09.11-.01946.04811-.01946.1019 0 .15.00683.05038.0317.09657.07.13l4 3.65c.01964.02301.04425.04127.07196.05339.02771.01213.05782.01781.08804.01661h.1c.02433-.02103.04176-.04891.05-.08.00489-.02644.00489-.05355 0-.08.01069-.03247.01069-.06752 0-.1v-3.65c.01128-.02692.01709-.05581.01709-.085 0-.02918-.00581-.05808-.01709-.085-.02302-.02483-.05084-.04472-.08179-.05847-.03094-.01375-.06435-.02108-.09821-.02153h-3.97ZM2.58031 3.60995c-.00942.04619-.00942.09381 0 .14.0194.039.051.0706.09.09.04235.0131.08766.0131.13 0h4.11c.03346-.00354.06496-.01753.09-.04.02039-.02778.03719-.05801.05-.09.00978-.03601.00978-.07398 0-.11V.599954C7.04354.544926 7.01793.493939 6.97782.455657 6.93772.417375 6.8856.394159 6.83031.389954H4.46031c-.03631.018585-.06728.046118-.09.08l-1.74 2.999996c-.02993.04081-.04731.08947-.05.14ZM13.3199 6.07998c.0316-.02116.0588-.04834.08-.08.0147-.04892.0147-.10109 0-.15-.0147-.04693-.0469-.08636-.09-.11-.0402-.03107-.0892-.04857-.14-.05H9.16989c-.05843-.0105-.1187.00013-.17.03-.02324.02161-.04153.04799-.05361.07734-.01208.02934-.01768.06095-.01639.09266v3.67a.1599177.1599177 0 0 0 0 .1c.01644.03199.04048.05945.07.08.01957.02803.04761.04906.08.06h.1c.05906.00129.11635-.0202.16-.06l3.98001-3.66ZM13.1701 3.85998c.046-.00083.0909-.01434.1297-.03905.0389-.0247.0701-.05963.0903-.10095.0092-.04285.0092-.08716 0-.13-.0058-.04675-.023-.09137-.05-.13l-1.74-3.000002c-.0227-.033881-.0536-.061415-.09-.08H9.17014c-.03321-.001415-.06635.004083-.09732.016146-.03097.012063-.0591.030428-.0826.053931-.02351.023503-.04187.051632-.05393.082604-.01207.030971-.01757.064111-.01615.097319V3.62998c.00747.05808.03592.11143.08.15.02302.02483.05085.04472.08179.05847.03094.01376.06435.02108.09821.02153h3.98996Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const HomeIcon: React.FC<props> = ({ size = 16, ...props }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_136_3237)">
        <path
          d="M20.2781 9.1875L18.375 7.28569V2.625C18.375 1.90312 17.7844 1.3125 17.0625 1.3125H15.75C15.0281 1.3125 14.4375 1.90312 14.4375 2.625V3.35081L11.8125 0.728437C11.4542 0.389813 11.1261 0 10.5 0C9.87394 0 9.54581 0.389813 9.1875 0.728437L0.721875 9.1875C0.312375 9.61406 0 9.92513 0 10.5C0 11.2389 0.567 11.8125 1.3125 11.8125H2.625V19.6875C2.625 20.4094 3.21563 21 3.9375 21H7.875V14.4375C7.875 13.7156 8.46562 13.125 9.1875 13.125H11.8125C12.5344 13.125 13.125 13.7156 13.125 14.4375V21H17.0625C17.7844 21 18.375 20.4094 18.375 19.6875V11.8125H19.6875C20.433 11.8125 21 11.2389 21 10.5C21 9.92513 20.6876 9.61406 20.2781 9.1875Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_136_3237">
          <rect width="21" height="21" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OpenLinkIcon: React.FC<props> = ({ size = 16, ...props }) => {
  const { view } = props;
  switch (view) {
    case "footer":
      return (
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_161_379)">
            <path
              d="M9.02012 4.88887C9.03583 5.25553 9.03583 5.66294 9.03583 6.11109C9.03583 7.22739 9.01226 8.0585 8.91012 8.6859C8.80798 9.31331 8.64298 9.68813 8.40726 9.93257C8.17155 10.177 7.80226 10.3563 7.20512 10.4541C6.60012 10.56 5.79869 10.5844 4.72226 10.5844C3.64583 10.5844 2.84441 10.56 2.23941 10.4541C1.63441 10.3481 1.27298 10.177 1.03726 9.93257C0.801549 9.68813 0.628691 9.30516 0.534406 8.6859C0.432263 8.0585 0.408691 7.22739 0.408691 6.11109C0.408691 4.99479 0.432263 4.16368 0.534406 3.53628C0.636549 2.90887 0.801549 2.53405 1.03726 2.28961C1.27298 2.04516 1.64226 1.8659 2.23941 1.76813C2.84441 1.6622 3.64583 1.63776 4.72226 1.63776C5.38226 1.63776 5.94012 1.6459 6.41155 1.6785"
              stroke="currentColor"
              strokeLinecap="round"
            />
            <path
              d="M9.02012 4.88887C9.03583 5.25553 9.03583 5.66294 9.03583 6.11109C9.03583 7.22739 9.01226 8.0585 8.91012 8.6859C8.80798 9.31331 8.64298 9.68813 8.40726 9.93257C8.17155 10.177 7.80226 10.3563 7.20512 10.4541C6.60012 10.56 5.79869 10.5844 4.72226 10.5844C3.64583 10.5844 2.84441 10.56 2.23941 10.4541C1.63441 10.3481 1.27298 10.177 1.03726 9.93257C0.801549 9.68813 0.628691 9.30516 0.534406 8.6859C0.432263 8.0585 0.408691 7.22739 0.408691 6.11109C0.408691 4.99479 0.432263 4.16368 0.534406 3.53628C0.636549 2.90887 0.801549 2.53405 1.03726 2.28961C1.27298 2.04516 1.64226 1.8659 2.23941 1.76813C2.84441 1.6622 3.64583 1.63776 4.72226 1.63776C5.38226 1.63776 5.94012 1.6459 6.41155 1.6785"
              stroke="currentColor"
              strokeOpacity="0.8"
              strokeLinecap="round"
            />
            <path
              d="M9.66431 0.79037C9.23217 0.79037 8.80003 0.79037 8.37574 0.79037C8.32074 0.79037 8.26574 0.79037 8.2186 0.774074C8.03003 0.717037 7.92788 0.537778 7.95145 0.334074C7.97503 0.146667 8.12431 0.00814815 8.31288 0C8.41503 0 8.52503 0 8.62717 0C9.27145 0 9.9236 0 10.5836 0C10.8507 0 11 0.154815 11 0.431852C11 1.20593 11 1.98 11 2.75407C11 3.05556 10.7486 3.25111 10.4893 3.15333C10.3322 3.0963 10.2379 2.94963 10.2379 2.77037C10.2379 2.33852 10.2379 1.91481 10.2379 1.48296V1.36074C10.2379 1.36074 10.175 1.41778 10.1515 1.44222C9.0986 2.53407 8.03788 3.63407 6.98503 4.72593C6.8986 4.81556 6.81217 4.88074 6.69431 4.88074C6.52931 4.88074 6.4036 4.81556 6.33288 4.66074C6.26217 4.50593 6.28574 4.35926 6.38788 4.22889C6.41145 4.1963 6.43503 4.17185 6.4586 4.14741C7.5036 3.05556 8.55645 1.97185 9.60145 0.88C9.62503 0.855556 9.66431 0.839259 9.69574 0.822963C9.68788 0.806667 9.67217 0.798518 9.66431 0.782222V0.79037Z"
              fill="currentColor"
            />
            <path
              d="M9.66431 0.79037C9.23217 0.79037 8.80003 0.79037 8.37574 0.79037C8.32074 0.79037 8.26574 0.79037 8.2186 0.774074C8.03003 0.717037 7.92788 0.537778 7.95145 0.334074C7.97503 0.146667 8.12431 0.00814815 8.31288 0C8.41503 0 8.52503 0 8.62717 0C9.27145 0 9.9236 0 10.5836 0C10.8507 0 11 0.154815 11 0.431852C11 1.20593 11 1.98 11 2.75407C11 3.05556 10.7486 3.25111 10.4893 3.15333C10.3322 3.0963 10.2379 2.94963 10.2379 2.77037C10.2379 2.33852 10.2379 1.91481 10.2379 1.48296V1.36074C10.2379 1.36074 10.175 1.41778 10.1515 1.44222C9.0986 2.53407 8.03788 3.63407 6.98503 4.72593C6.8986 4.81556 6.81217 4.88074 6.69431 4.88074C6.52931 4.88074 6.4036 4.81556 6.33288 4.66074C6.26217 4.50593 6.28574 4.35926 6.38788 4.22889C6.41145 4.1963 6.43503 4.17185 6.4586 4.14741C7.5036 3.05556 8.55645 1.97185 9.60145 0.88C9.62503 0.855556 9.66431 0.839259 9.69574 0.822963C9.68788 0.806667 9.67217 0.798518 9.66431 0.782222V0.79037Z"
              fill="currentColor"
              fillOpacity="0.8"
            />
          </g>
          <defs>
            <clipPath id="clip0_161_379">
              <rect width="11" height="11" fill="currentColor" />
            </clipPath>
          </defs>
        </svg>
      );
    case "render":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_230_310)">
            <path
              d="M11.48 6.00001C11.5 6.45001 11.5 6.95001 11.5 7.50001C11.5 8.87001 11.47 9.89001 11.34 10.66C11.21 11.43 11 11.89 10.7 12.19C10.4 12.49 9.93002 12.71 9.17002 12.83C8.40002 12.96 7.38002 12.99 6.01002 12.99C4.64002 12.99 3.62002 12.96 2.85002 12.83C2.08002 12.7 1.62002 12.49 1.32002 12.19C1.02002 11.89 0.80002 11.42 0.68002 10.66C0.55002 9.89001 0.52002 8.87001 0.52002 7.50001C0.52002 6.13001 0.55002 5.11001 0.68002 4.34001C0.81002 3.57001 1.02002 3.11001 1.32002 2.81001C1.62002 2.51001 2.09002 2.29001 2.85002 2.17001C3.62002 2.04001 4.64002 2.01001 6.01002 2.01001C6.85002 2.01001 7.56002 2.02001 8.16002 2.06001"
              stroke="#B1B1B1"
              strokeLinecap="round"
            />
            <path
              d="M12.3 0.97C11.75 0.97 11.2 0.97 10.66 0.97C10.59 0.97 10.52 0.97 10.46 0.95C10.22 0.88 10.09 0.66 10.12 0.41C10.15 0.18 10.34 0.01 10.58 0C10.71 0 10.85 0 10.98 0C11.8 0 12.63 0 13.47 0C13.81 0 14 0.19 14 0.53C14 1.48 14 2.43 14 3.38C14 3.75 13.68 3.99 13.35 3.87C13.15 3.8 13.03 3.62 13.03 3.4C13.03 2.87 13.03 2.35 13.03 1.82V1.67C13.03 1.67 12.95 1.74 12.92 1.77C11.58 3.11 10.23 4.46 8.89003 5.8C8.78003 5.91 8.67003 5.99 8.52003 5.99C8.31003 5.99 8.15003 5.91 8.06003 5.72C7.97003 5.53 8.00003 5.35 8.13003 5.19C8.16003 5.15 8.19003 5.12 8.22003 5.09C9.55003 3.75 10.89 2.42 12.22 1.08C12.25 1.05 12.3 1.03 12.34 1.01C12.33 0.99 12.31 0.98 12.3 0.96V0.97Z"
              fill="#B1B1B1"
            />
          </g>
          <defs>
            <clipPath id="clip0_230_310">
              <rect width="14" height="13.5" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    default:
      return (
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_130_2258)">
            <path
              d="M18.86 10.2222C18.8928 10.9889 18.8928 11.8407 18.8928 12.7778C18.8928 15.1118 18.8435 16.8496 18.63 18.1615C18.4164 19.4733 18.0714 20.257 17.5785 20.7681C17.0857 21.2793 16.3135 21.6541 15.065 21.8585C13.8 22.08 12.1242 22.1311 9.87353 22.1311C7.62282 22.1311 5.9471 22.08 4.6821 21.8585C3.4171 21.637 2.66139 21.2793 2.16853 20.7681C1.67568 20.257 1.31425 19.4563 1.11711 18.1615C0.903534 16.8496 0.854248 15.1118 0.854248 12.7778C0.854248 10.4437 0.903534 8.70592 1.11711 7.39407C1.33068 6.08222 1.67568 5.29851 2.16853 4.7874C2.66139 4.27629 3.43353 3.90148 4.6821 3.69703C5.9471 3.47555 7.62282 3.42444 9.87353 3.42444C11.2535 3.42444 12.42 3.44148 13.4057 3.50962"
              stroke="currentColor"
              strokeLinecap="round"
            />
            <path
              d="M20.2072 1.65259C19.3036 1.65259 18.4001 1.65259 17.5129 1.65259C17.3979 1.65259 17.2829 1.65259 17.1843 1.61852C16.7901 1.49926 16.5765 1.12444 16.6258 0.698519C16.6751 0.306667 16.9872 0.017037 17.3815 0C17.5951 0 17.8251 0 18.0386 0C19.3858 0 20.7493 0 22.1293 0C22.6879 0 23.0001 0.323704 23.0001 0.902963C23.0001 2.52148 23.0001 4.14 23.0001 5.75852C23.0001 6.38889 22.4743 6.79778 21.9322 6.59333C21.6036 6.47407 21.4065 6.16741 21.4065 5.79259C21.4065 4.88963 21.4065 4.0037 21.4065 3.10074V2.84519C21.4065 2.84519 21.2751 2.96444 21.2258 3.01556C19.0243 5.29852 16.8065 7.59852 14.6051 9.88148C14.4243 10.0689 14.2436 10.2052 13.9972 10.2052C13.6522 10.2052 13.3893 10.0689 13.2415 9.74519C13.0936 9.42148 13.1429 9.11482 13.3565 8.84222C13.4058 8.77407 13.4551 8.72296 13.5043 8.67185C15.6893 6.38889 17.8908 4.12296 20.0758 1.84C20.1251 1.78889 20.2072 1.75481 20.2729 1.72074C20.2565 1.68667 20.2236 1.66963 20.2072 1.63556V1.65259Z"
              fill="CurrentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_130_2258">
              <rect width="23" height="23" fill="currentColor" />
            </clipPath>
          </defs>
        </svg>
      );
  }
};

export const PlusIcon: React.FC<props> = ({ size = 16, ...props }) => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 7.25V14.25"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 10.75H14"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.5 10.75C0.5 8.36032 0.559824 6.54728 0.790196 5.16028C1.01999 3.77677 1.40998 2.88088 2.02043 2.27043C2.63088 1.65998 3.52677 1.26999 4.91028 1.0402C6.29728 0.809824 8.11032 0.75 10.5 0.75C12.8897 0.75 14.7027 0.809824 16.0897 1.0402C17.4732 1.26999 18.3691 1.65998 18.9796 2.27043C19.59 2.88088 19.98 3.77677 20.2098 5.16028C20.4402 6.54728 20.5 8.36032 20.5 10.75C20.5 13.1397 20.4402 14.9527 20.2098 16.3397C19.98 17.7232 19.59 18.6191 18.9796 19.2296C18.3691 19.84 17.4732 20.23 16.0897 20.4598C14.7027 20.6902 12.8897 20.75 10.5 20.75C8.11032 20.75 6.29728 20.6902 4.91028 20.4598C3.52677 20.23 2.63088 19.84 2.02043 19.2296C1.40998 18.6191 1.01999 17.7232 0.790196 16.3397C0.559824 14.9527 0.5 13.1397 0.5 10.75Z"
        stroke="currentColor"
      />
    </svg>
  );
};

export const MenuIcon: React.FC<props> = ({ size = 16, ...props }) => {
  const { view } = props;
  return view === "footer" ? (
    <svg
      width="16"
      height="10"
      viewBox="0 0 9 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_179_408)">
        <path
          d="M6.56195 4.24779C6.56195 4.29167 6.57012 4.33555 6.5855 4.37618C6.60089 4.41681 6.623 4.45365 6.65136 4.48398C6.70857 4.54683 6.78549 4.58258 6.86529 4.58258H11.7005C11.7553 4.58312 11.8091 4.56633 11.8558 4.53491C11.9029 4.50349 11.9408 4.45798 11.9663 4.40327C11.9918 4.34909 12.0033 4.28788 11.9995 4.22666C11.9956 4.16544 11.9774 4.10639 11.9457 4.05655L9.83861 0.14141C9.80928 0.0975292 9.7713 0.0617744 9.72708 0.0373962C9.68429 0.0124762 9.6367 -0.000525473 9.58863 1.62652e-05H6.84654C6.76626 1.62652e-05 6.68934 0.0368545 6.63261 0.100238C6.57589 0.162538 6.54368 0.247591 6.54224 0.336436L6.56195 4.24779Z"
          fill="currentColor"
        />
        <path
          d="M6.54272 6.11782V10.6841C6.54272 10.7459 6.56003 10.806 6.59176 10.8564C6.62445 10.9084 6.67012 10.949 6.72348 10.9729C6.7778 10.9978 6.83693 11.0054 6.8951 10.9956C6.95279 10.9864 7.00711 10.9583 7.05134 10.9155L11.8985 6.3524C11.9428 6.31014 11.974 6.2538 11.988 6.19096C12.0019 6.12866 11.9966 6.06311 11.9735 6.0046C11.9505 5.94447 11.912 5.89354 11.862 5.85941C11.8106 5.82312 11.751 5.80416 11.6904 5.8047H6.8451C6.76674 5.80524 6.69127 5.83774 6.63358 5.89734C6.60618 5.92496 6.58359 5.95909 6.5682 5.99702C6.55234 6.03548 6.54369 6.07611 6.54272 6.11782Z"
          fill="currentColor"
        />
        <path
          d="M5.44723 4.24777C5.44627 4.33662 5.41358 4.42167 5.35685 4.48397C5.29964 4.54681 5.22273 4.58257 5.14293 4.58257H0.30341C0.248607 4.58257 0.194765 4.56523 0.148615 4.53273C0.101984 4.50076 0.0630447 4.4558 0.0370852 4.40163C0.0125679 4.34745 0.00103041 4.28678 0.00487625 4.2261C0.00824137 4.16543 0.0265091 4.10692 0.0572759 4.05654L2.16384 0.141394C2.19316 0.0975129 2.23114 0.0617582 2.27537 0.03738C2.31815 0.0130017 2.36526 0 2.41334 0H5.15302C5.2333 0 5.31022 0.0368382 5.36695 0.100222C5.39531 0.131101 5.41742 0.167939 5.43281 0.208028C5.44819 0.248658 5.45588 0.291997 5.45636 0.33642L5.44723 4.24777Z"
          fill="currentColor"
        />
        <path
          d="M5.45633 6.11787V10.6842C5.45729 10.7459 5.44047 10.8066 5.40826 10.8565C5.37509 10.909 5.32894 10.9496 5.27558 10.9729C5.22126 10.9979 5.16213 11.0054 5.10396 10.9957C5.04675 10.9859 4.99291 10.9583 4.94916 10.9155L0.0971475 6.35299C0.0529203 6.31073 0.0221535 6.25439 0.00773161 6.19155C-0.00572885 6.12925 -0.000921544 6.06424 0.0211921 6.00519C0.0442671 5.94506 0.0832063 5.89468 0.132722 5.86001C0.184641 5.82371 0.244251 5.80475 0.305304 5.80475H5.15395C5.23279 5.80529 5.30827 5.83779 5.36692 5.89739C5.3948 5.92501 5.41691 5.95914 5.4323 5.99707C5.44768 6.03553 5.45585 6.07616 5.45633 6.11787Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_179_408">
          <rect width="12" height="11" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      width="26"
      height="21"
      viewBox="0 0 26 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2081 8.10834C14.2101 8.27793 14.2801 8.44004 14.4033 8.55997C14.5265 8.6799 14.693 8.74811 14.8671 8.75H25.3515C25.4708 8.74814 25.5874 8.71479 25.6887 8.6535C25.79 8.59221 25.8724 8.50527 25.927 8.40198C25.9816 8.29868 26.0063 8.18289 25.9986 8.06697C25.9909 7.95105 25.951 7.83934 25.8832 7.74375L21.315 0.269791C21.2551 0.186653 21.1755 0.118755 21.0829 0.0718057C20.9904 0.0248565 20.8877 0.000230118 20.7833 0H14.8372C14.663 0.00189507 14.4965 0.070108 14.3733 0.190036C14.2502 0.309963 14.1801 0.472075 14.1782 0.641668L14.2081 8.10834Z"
        fill="currentColor"
      />
      <path
        d="M14.1782 11.6808V20.3983C14.1773 20.515 14.2138 20.6294 14.2834 20.7274C14.353 20.8254 14.4524 20.9026 14.5695 20.9496C14.6867 20.9965 14.8163 21.0111 14.9424 20.9915C15.0685 20.972 15.1856 20.9192 15.2791 20.8396L25.7902 12.1289C25.8873 12.046 25.9548 11.9383 25.9839 11.8199C26.013 11.7015 26.0024 11.5779 25.9535 11.465C25.9045 11.3522 25.8195 11.2555 25.7094 11.1874C25.5993 11.1193 25.4694 11.083 25.3364 11.0833H14.8328C14.6598 11.0851 14.4944 11.1486 14.372 11.2603C14.2497 11.3719 14.1801 11.5229 14.1782 11.6808Z"
        fill="currentColor"
      />
      <path
        d="M11.7919 8.10834C11.7899 8.27793 11.7199 8.44004 11.5967 8.55997C11.4735 8.6799 11.307 8.74811 11.1329 8.75H0.648477C0.529185 8.74814 0.412649 8.71479 0.3113 8.6535C0.209952 8.59221 0.127594 8.50527 0.0730113 8.40198C0.018429 8.29868 -0.00632998 8.18289 0.00137642 8.06697C0.00908282 7.95105 0.0489649 7.83934 0.116768 7.74375L4.68497 0.269791C4.74493 0.186653 4.82452 0.118755 4.91705 0.0718057C5.00958 0.0248565 5.11234 0.000230118 5.21667 0H11.1628C11.337 0.00189507 11.5035 0.070108 11.6267 0.190036C11.7498 0.309963 11.8199 0.472075 11.8218 0.641668L11.7919 8.10834Z"
        fill="currentColor"
      />
      <path
        d="M11.8218 11.6808V20.3983C11.8227 20.515 11.7862 20.6294 11.7166 20.7274C11.647 20.8254 11.5476 20.9026 11.4305 20.9496C11.3133 20.9965 11.1837 21.0111 11.0576 20.9915C10.9315 20.972 10.8144 20.9192 10.7209 20.8396L0.209816 12.1289C0.112712 12.046 0.0452025 11.9383 0.0160785 11.8199C-0.0130455 11.7015 -0.00243401 11.5779 0.0465297 11.465C0.0954934 11.3522 0.180541 11.2555 0.290599 11.1874C0.400658 11.1193 0.530628 11.083 0.663585 11.0833H11.1672C11.3402 11.0851 11.5056 11.1486 11.628 11.2603C11.7503 11.3719 11.8199 11.5229 11.8218 11.6808Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const LogOutIcon: React.FC<props> = ({ size = 16, ...props }) => {
  return (
    <svg
      width="9"
      height="10"
      viewBox="0 0 9 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_160_379)">
        <path
          d="M4.89132 9.58335C3.77447 9.58335 2.94295 9.55835 2.31523 9.45002C1.68751 9.34168 1.31251 9.16668 1.06795 8.91668C0.82338 8.66668 0.644032 8.27502 0.546206 7.64168C0.440228 7.00002 0.415771 6.15002 0.415771 5.00835C0.415771 3.86668 0.440228 3.01668 0.546206 2.37502C0.652185 1.73335 0.82338 1.35002 1.06795 1.10002C1.31251 0.850016 1.69566 0.666683 2.31523 0.566683C2.94295 0.45835 3.77447 0.43335 4.89132 0.43335"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="bevel"
        />
        <path
          d="M7.62228 4.57501C7.30434 4.25001 6.99456 3.92501 6.67663 3.60001C6.63586 3.55835 6.5951 3.51668 6.57065 3.46668C6.47282 3.29168 6.52173 3.07501 6.68478 2.95001C6.83152 2.83335 7.04347 2.84168 7.19021 2.97501C7.27173 3.05001 7.3451 3.13335 7.41847 3.20835C7.89945 3.70001 8.38043 4.19168 8.85326 4.68335C9.04891 4.88335 9.04891 5.10835 8.85326 5.30835C8.30706 5.86668 7.76086 6.42501 7.20652 6.98335C6.98641 7.20001 6.66847 7.15001 6.54619 6.88335C6.47282 6.72501 6.50543 6.55001 6.63587 6.41668C6.9375 6.10835 7.23913 5.80001 7.54891 5.49168L7.63858 5.40001C7.58152 5.40001 7.54891 5.40001 7.5163 5.40001C5.96739 5.40001 4.41847 5.40001 2.86956 5.39168C2.74728 5.39168 2.63315 5.37501 2.54347 5.28335C2.42119 5.15835 2.38043 5.01668 2.4375 4.85001C2.49456 4.68335 2.61684 4.59168 2.78804 4.57501C2.8288 4.57501 2.86141 4.57501 2.90217 4.57501C4.44293 4.57501 5.98369 4.57501 7.5163 4.58335C7.54891 4.58335 7.58967 4.60001 7.62228 4.60835C7.62228 4.59168 7.62228 4.57501 7.62228 4.55835V4.57501Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_160_379">
          <rect width="9" height="10" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const InfoIcon: React.FC<props> = ({ size = 16, ...props }) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="4 0 9 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 8.66667V6.5"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 4.875H6.50542"
        stroke="currentcolor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.125 6.5C2.125 5.39001 2.15318 4.56837 2.25611 3.94866C2.35847 3.33243 2.52521 2.97971 2.75246 2.75246C2.97971 2.52521 3.33243 2.35847 3.94866 2.25611C4.56837 2.15318 5.39001 2.125 6.5 2.125C7.60999 2.125 8.43163 2.15318 9.05134 2.25611C9.66757 2.35847 10.0203 2.52521 10.2475 2.75246C10.4748 2.97971 10.6415 3.33243 10.7439 3.94866C10.8468 4.56837 10.875 5.39001 10.875 6.5C10.875 7.60999 10.8468 8.43163 10.7439 9.05134C10.6415 9.66757 10.4748 10.0203 10.2475 10.2475C10.0203 10.4748 9.66757 10.6415 9.05134 10.7439C8.43163 10.8468 7.60999 10.875 6.5 10.875C5.39001 10.875 4.56837 10.8468 3.94866 10.7439C3.33243 10.6415 2.97971 10.4748 2.75246 10.2475C2.52521 10.0203 2.35847 9.66757 2.25611 9.05134C2.15318 8.43163 2.125 7.60999 2.125 6.5Z"
        stroke="currentColor"
      />
    </svg>
  );
};
export const DownloadIcon: React.FC<props> = ({ size = 16, ...props }) => {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.6238 5.53967C8.60875 6.04606 8.57112 6.46806 8.51845 6.82867C8.42062 7.41947 8.26259 7.77241 8.03684 8.00259C7.81109 8.23277 7.45741 8.40156 6.8855 8.49363C6.30607 8.59338 5.53851 8.6164 4.50758 8.6164C3.47664 8.6164 2.70908 8.59338 2.12965 8.49363C1.55022 8.39389 1.20407 8.23277 0.978314 8.00259C0.752561 7.77241 0.58701 7.41179 0.496709 6.82867C0.436508 6.46039 0.406408 6.02305 0.391357 5.48596"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M8.6238 5.53967C8.60875 6.04606 8.57112 6.46806 8.51845 6.82867C8.42062 7.41947 8.26259 7.77241 8.03684 8.00259C7.81109 8.23277 7.45741 8.40156 6.8855 8.49363C6.30607 8.59338 5.53851 8.6164 4.50758 8.6164C3.47664 8.6164 2.70908 8.59338 2.12965 8.49363C1.55022 8.39389 1.20407 8.23277 0.978314 8.00259C0.752561 7.77241 0.58701 7.41179 0.496709 6.82867C0.436508 6.46039 0.406408 6.02305 0.391357 5.48596"
        stroke="currentColor"
        strokeOpacity="0.8"
        strokeLinecap="round"
      />
      <path
        d="M5.00422 4.91046C5.2977 4.61123 5.59118 4.31967 5.88466 4.02044C5.92228 3.98207 5.95991 3.94371 6.00506 3.92069C6.16308 3.82862 6.35874 3.87466 6.47161 4.02811C6.57696 4.16622 6.56944 4.36571 6.44904 4.50381C6.38131 4.58054 6.30606 4.64959 6.23833 4.71865C5.79435 5.17133 5.35037 5.62402 4.90639 6.06903C4.72579 6.25317 4.52262 6.25317 4.34201 6.06903C3.83783 5.55496 3.33365 5.0409 2.82947 4.51916C2.63382 4.312 2.67897 4.01276 2.91977 3.89768C3.06275 3.82862 3.22078 3.85931 3.34118 3.98207C3.61961 4.26596 3.89803 4.54985 4.17646 4.84141L4.25924 4.92581C4.25924 4.8721 4.25924 4.84141 4.25924 4.81072C4.25924 3.35292 4.25924 1.89512 4.26676 0.437317C4.26676 0.322228 4.28181 0.214811 4.36459 0.130412C4.47746 0.0153224 4.60539 -0.0230408 4.75589 0.0306677C4.90639 0.0843761 4.98917 0.199466 5.00422 0.360591C5.00422 0.398954 5.00422 0.429645 5.00422 0.468008C5.00422 1.91814 5.00422 3.36826 4.9967 4.81072C4.9967 4.84141 4.98165 4.87977 4.97412 4.91046C4.98917 4.91046 5.00422 4.91046 5.01927 4.91046H5.00422Z"
        fill="currentColor"
      />
      <path
        d="M5.00422 4.91046C5.2977 4.61123 5.59118 4.31967 5.88466 4.02044C5.92228 3.98207 5.95991 3.94371 6.00506 3.92069C6.16308 3.82862 6.35874 3.87466 6.47161 4.02811C6.57696 4.16622 6.56944 4.36571 6.44904 4.50381C6.38131 4.58054 6.30606 4.64959 6.23833 4.71865C5.79435 5.17133 5.35037 5.62402 4.90639 6.06903C4.72579 6.25317 4.52262 6.25317 4.34201 6.06903C3.83783 5.55496 3.33365 5.0409 2.82947 4.51916C2.63382 4.312 2.67897 4.01276 2.91977 3.89768C3.06275 3.82862 3.22078 3.85931 3.34118 3.98207C3.61961 4.26596 3.89803 4.54985 4.17646 4.84141L4.25924 4.92581C4.25924 4.8721 4.25924 4.84141 4.25924 4.81072C4.25924 3.35292 4.25924 1.89512 4.26676 0.437317C4.26676 0.322228 4.28181 0.214811 4.36459 0.130412C4.47746 0.0153224 4.60539 -0.0230408 4.75589 0.0306677C4.90639 0.0843761 4.98917 0.199466 5.00422 0.360591C5.00422 0.398954 5.00422 0.429645 5.00422 0.468008C5.00422 1.91814 5.00422 3.36826 4.9967 4.81072C4.9967 4.84141 4.98165 4.87977 4.97412 4.91046C4.98917 4.91046 5.00422 4.91046 5.01927 4.91046H5.00422Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
    </svg>
  );
};
export const OpenProjectIcon: React.FC<props> = ({ size = 16, ...props }) => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_136_3239)">
        <path
          d="M7.55998 3.55555C7.5714 3.82221 7.5714 4.11851 7.5714 4.44443C7.5714 5.25629 7.55426 5.86073 7.47998 6.31703C7.40569 6.77332 7.28569 7.04592 7.11426 7.22369C6.94283 7.40147 6.67426 7.53184 6.23998 7.60295C5.79998 7.67999 5.21712 7.69777 4.43426 7.69777C3.6514 7.69777 3.06855 7.67999 2.62855 7.60295C2.18855 7.52592 1.92569 7.40147 1.75426 7.22369C1.58283 7.04592 1.45712 6.7674 1.38855 6.31703C1.31426 5.86073 1.29712 5.25629 1.29712 4.44443C1.29712 3.63258 1.31426 3.02814 1.38855 2.57184C1.46283 2.11555 1.58283 1.84295 1.75426 1.66518C1.92569 1.4874 2.19426 1.35703 2.62855 1.28592C3.06855 1.20888 3.6514 1.1911 4.43426 1.1911C4.91426 1.1911 5.31998 1.19703 5.66283 1.22073"
          stroke="#B1B1B1"
          strokeLinecap="round"
        />
        <path
          d="M8.02859 0.574815C7.7143 0.574815 7.40002 0.574815 7.09145 0.574815C7.05145 0.574815 7.01145 0.574815 6.97716 0.562963C6.84002 0.521481 6.76573 0.391111 6.78288 0.242963C6.80002 0.106667 6.90859 0.00592593 7.04573 0C7.12002 0 7.20002 0 7.2743 0C7.74288 0 8.21716 0 8.69716 0C8.89145 0 9.00002 0.112593 9.00002 0.314074C9.00002 0.877037 9.00002 1.44 9.00002 2.00296C9.00002 2.22222 8.81716 2.36444 8.62859 2.29333C8.5143 2.25185 8.44573 2.14519 8.44573 2.01481C8.44573 1.70074 8.44573 1.39259 8.44573 1.07852V0.98963C8.44573 0.98963 8.40002 1.03111 8.38288 1.04889C7.61716 1.84296 6.84573 2.64296 6.08002 3.43704C6.01716 3.50222 5.9543 3.54963 5.86859 3.54963C5.74859 3.54963 5.65716 3.50222 5.60573 3.38963C5.5543 3.27704 5.57145 3.17037 5.64573 3.07556C5.66288 3.05185 5.68002 3.03407 5.69716 3.0163C6.45716 2.22222 7.22288 1.43407 7.98288 0.64C8.00002 0.622222 8.02859 0.61037 8.05145 0.598518C8.04573 0.586667 8.0343 0.580741 8.02859 0.568889V0.574815Z"
          fill="#B1B1B1"
        />
      </g>
      <defs>
        <clipPath id="clip0_136_3239">
          <rect width="9" height="9" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const LoadingIcon: React.FC<props> = ({ size = 16, ...props }) => {
  const { className } = props;
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle
        cx="7"
        cy="7"
        r="7"
        transform="matrix(0.600716 -0.799462 -0.799462 -0.600716 9.19238 17.6025)"
        stroke="url(#paint0_linear_93_3300)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_93_3300"
          x1="-5.76254e-08"
          y1="6.9229"
          x2="14"
          y2="6.9229"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF154D" />
          <stop offset="1" stop-color="#374146" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const StaticLoadingIcon: React.FC<props> = ({ size = 16, ...props }) => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.19699 5.01933C8.19811 5.12431 8.23853 5.22466 8.30959 5.29891C8.38065 5.37315 8.47671 5.41537 8.57719 5.41655H14.6259C14.6947 5.4154 14.7619 5.39475 14.8204 5.35681C14.8789 5.31886 14.9264 5.26505 14.9579 5.2011C14.9894 5.13716 15.0037 5.06548 14.9992 4.99372C14.9948 4.92196 14.9718 4.8528 14.9326 4.79363L12.2971 0.166891C12.2625 0.115425 12.2166 0.0733929 12.1632 0.0443291C12.1099 0.0152653 12.0506 2.03836e-05 11.9904 -0.00012207H8.55991C8.45942 0.00105107 8.36337 0.0432781 8.29231 0.117519C8.22125 0.19176 8.18083 0.292115 8.17971 0.397101L8.19699 5.01933Z"
        fill="#FF154D"
      />
      <path
        d="M8.17972 7.23082V12.6274C8.17919 12.6996 8.2003 12.7705 8.24042 12.8311C8.28055 12.8918 8.33794 12.9396 8.40551 12.9686C8.47307 12.9977 8.54785 13.0067 8.62061 12.9946C8.69336 12.9825 8.7609 12.9498 8.81488 12.9005L14.879 7.50821C14.935 7.4569 14.9739 7.39026 14.9907 7.31696C15.0075 7.24366 15.0014 7.16711 14.9732 7.09727C14.9449 7.02743 14.8958 6.96753 14.8323 6.92539C14.7689 6.88324 14.6939 6.86079 14.6172 6.86096H8.55738C8.45757 6.86206 8.36215 6.90137 8.29157 6.9705C8.22098 7.03963 8.18083 7.13306 8.17972 7.23082Z"
        fill="#FF154D"
      />
      <path
        d="M6.80301 5.01933C6.80189 5.12431 6.76147 5.22466 6.69041 5.29891C6.61935 5.37315 6.52329 5.41537 6.42281 5.41655H0.374122C0.305299 5.4154 0.238066 5.39475 0.179596 5.35681C0.121126 5.31886 0.0736117 5.26505 0.0421219 5.2011C0.0106321 5.13716 -0.00365191 5.06548 0.000794087 4.99372C0.00524009 4.92196 0.028249 4.8528 0.0673664 4.79363L2.70287 0.166891C2.73746 0.115425 2.78338 0.0733929 2.83676 0.0443291C2.89014 0.0152653 2.94942 2.03836e-05 3.00962 -0.00012207H6.44009C6.54058 0.00105107 6.63663 0.0432781 6.70769 0.117519C6.77875 0.19176 6.81917 0.292115 6.82029 0.397101L6.80301 5.01933Z"
        fill="#FF154D"
      />
      <path
        d="M6.82028 7.23082V12.6274C6.82081 12.6996 6.7997 12.7705 6.75958 12.8311C6.71945 12.8918 6.66206 12.9396 6.59449 12.9686C6.52693 12.9977 6.45215 13.0067 6.37939 12.9946C6.30664 12.9825 6.2391 12.9498 6.18512 12.9005L0.121048 7.50821C0.065026 7.4569 0.0260784 7.39026 0.00927606 7.31696C-0.00752625 7.24366 -0.00140424 7.16711 0.0268441 7.09727C0.0550924 7.02743 0.104158 6.96753 0.167653 6.92539C0.231149 6.88324 0.306131 6.86079 0.382837 6.86096H6.44262C6.54243 6.86206 6.63785 6.90137 6.70843 6.9705C6.77902 7.03963 6.81917 7.13306 6.82028 7.23082Z"
        fill="#FF154D"
      />
    </svg>
  );
};
export const CloseIcon: React.FC<props> = ({ size = 20, ...props }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.65625 1.28113L8.71875 0.343628L5 4.06238L1.28125 0.343628L0.34375 1.28113L4.0625 4.99988L0.34375 8.71863L1.28125 9.65613L5 5.93738L8.71875 9.65613L9.65625 8.71863L5.9375 4.99988L9.65625 1.28113Z"
        fill="#B1B1B1"
      />
    </svg>
  );
};
export const WarningIcon: React.FC<props> = ({ size = 20, ...props }) => {
  return (
    <svg
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_434_2144)">
        <path
          d="M10.5049 18.9965C8.08551 18.9965 5.66586 19.0071 3.24651 18.9917C2.13077 18.9847 1.22742 18.526 0.600334 17.5964C0.221563 17.0348 -0.0107947 16.4208 0.000255303 15.7324C0.00915673 15.1949 0.148817 14.6944 0.418622 14.2288C2.82815 10.0705 5.23675 5.91189 7.6475 1.75482C8.13677 0.911028 8.83047 0.316424 9.8041 0.0817997C11.1448 -0.241453 12.5881 0.414462 13.2643 1.60337C14.3466 3.50677 15.4547 5.3962 16.5526 7.2908C17.8946 9.60669 19.2451 11.9177 20.5767 14.2394C21.1543 15.2468 21.1289 16.2696 20.5761 17.2928C20.2237 17.9451 19.7433 18.4505 19.0481 18.7419C18.6279 18.9179 18.188 18.9962 17.7328 18.9962C15.3236 18.9962 12.9144 18.9962 10.5052 18.9962L10.5049 18.9965ZM10.5638 17.7533C12.9626 17.7533 15.361 17.7512 17.7598 17.7545C18.5214 17.7554 19.095 17.4847 19.4397 16.7699C19.739 16.1492 19.7571 15.5555 19.4124 14.9596C17.0029 10.7968 14.5918 6.63488 12.1768 2.47509C12.0764 2.30208 11.9466 2.13787 11.8017 1.99916C10.914 1.14869 9.32465 1.39545 8.94742 2.45414C8.93913 2.47752 8.92194 2.49785 8.90936 2.51971C6.50843 6.66433 4.10719 10.8086 1.70779 14.9536C0.980026 16.2105 1.88766 17.753 3.35272 17.7533C5.75641 17.7533 8.1601 17.7533 10.5641 17.7533H10.5638Z"
          fill="currentColor"
        />
        <path
          d="M11.1873 9.51334C11.1873 10.3323 11.1903 11.1512 11.186 11.9701C11.1836 12.4751 10.7947 12.7717 10.2993 12.6494C10.0365 12.5847 9.87629 12.4141 9.82319 12.151C9.8103 12.0869 9.80661 12.0205 9.80661 11.9549C9.80569 10.3171 9.80447 8.67926 9.80661 7.04144C9.80723 6.50178 10.2455 6.19188 10.7523 6.36489C10.9862 6.44472 11.1231 6.60892 11.1698 6.84537C11.1854 6.92398 11.1866 7.00624 11.1866 7.08667C11.1879 7.89556 11.1873 8.70415 11.1873 9.51304V9.51334Z"
          fill="currentColor"
        />
        <path
          d="M11.1725 14.1649C11.171 14.5303 10.8693 14.8293 10.4997 14.8317C10.1258 14.8341 9.81921 14.5285 9.82075 14.1554C9.82228 13.7882 10.1222 13.4919 10.4939 13.4901C10.8708 13.488 11.1741 13.7897 11.1725 14.1649Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_434_2144">
          <rect width="21" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ErrorWarningIcon: React.FC<props> = ({ size = 20, ...props }) => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.49997 14.875C4.49997 12.4 4.5619 10.5209 4.80077 9.08273C5.03906 7.64806 5.44393 6.71596 6.07993 6.07996C6.71593 5.44396 7.64803 5.03909 9.0827 4.8008C10.5208 4.56193 12.4 4.5 14.875 4.5C17.35 4.5 19.2291 4.56193 20.6672 4.8008C22.1019 5.03909 23.034 5.44396 23.67 6.07996C24.306 6.71596 24.7109 7.64806 24.9492 9.08273C25.188 10.5209 25.25 12.4 25.25 14.875C25.25 17.35 25.188 19.2291 24.9492 20.6673C24.7109 22.1019 24.306 23.034 23.67 23.67C23.034 24.306 22.1019 24.7109 20.6672 24.9492C19.2291 25.1881 17.35 25.25 14.875 25.25C12.4 25.25 10.5208 25.1881 9.0827 24.9492C7.64803 24.7109 6.71593 24.306 6.07993 23.67C5.44393 23.034 5.03906 22.1019 4.80077 20.6673C4.5619 19.2291 4.49997 17.35 4.49997 14.875Z"
        stroke="#FF000F"
      />
      <path
        d="M15.9985 13.0208C15.9985 14.0508 16.0029 15.0809 15.9967 16.111C15.9931 16.7463 15.4307 17.1193 14.7142 16.9654C14.3342 16.8841 14.1025 16.6695 14.0257 16.3385C14.0071 16.258 14.0017 16.1744 14.0017 16.0919C14.0004 14.0317 13.9986 11.9716 14.0017 9.91146C14.0026 9.23264 14.6365 8.84283 15.3694 9.06045C15.7077 9.16086 15.9057 9.36741 15.9732 9.66482C15.9958 9.76371 15.9976 9.86717 15.9976 9.96835C15.9994 10.9858 15.9985 12.0033 15.9985 13.0208Z"
        fill="#FF000F"
      />
      <path
        d="M16 19.0059C15.9977 19.5507 15.5513 19.9964 15.0045 20C14.4514 20.0036 13.9977 19.548 14 18.9919C14.0023 18.4444 14.446 18.0027 14.9959 18C15.5536 17.9968 16.0023 18.4466 16 19.0059Z"
        fill="#FF000F"
      />
    </svg>
  );
};
export const SelectIcon: React.FC<props> = ({ size = 20, ...props }) => {
  const { selectView } = props;
  const middleSvg = () => {
    switch (selectView) {
      case "unselect":
        return (
          <svg
            width="13.5"
            height="13.5"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 6H8"
              stroke="currentColor"
              strokeWidth="1.33"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M0.5 6C0.5 4.63407 0.534512 3.61416 0.66293 2.84099C0.79077 2.0713 1.00216 1.60994 1.30605 1.30605C1.60994 1.00216 2.0713 0.79077 2.84099 0.66293C3.61416 0.534512 4.63407 0.5 6 0.5C7.36593 0.5 8.38584 0.534512 9.15901 0.66293C9.9287 0.79077 10.3901 1.00216 10.6939 1.30605C10.9978 1.60994 11.2092 2.0713 11.3371 2.84099C11.4655 3.61416 11.5 4.63407 11.5 6C11.5 7.36593 11.4655 8.38584 11.3371 9.15901C11.2092 9.9287 10.9978 10.3901 10.6939 10.6939C10.3901 10.9978 9.9287 11.2092 9.15901 11.3371C8.38584 11.4655 7.36593 11.5 6 11.5C4.63407 11.5 3.61416 11.4655 2.84099 11.3371C2.0713 11.2092 1.60994 10.9978 1.30605 10.6939C1.00216 10.3901 0.79077 9.9287 0.66293 9.15901C0.534512 8.38584 0.5 7.36593 0.5 6Z"
              stroke="currentColor"
            />
          </svg>
        );
      case "selectAll":
        return (
          <svg
            width="13.5"
            height="13.5"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.5 6C0.5 4.63407 0.534512 3.61416 0.66293 2.84099C0.79077 2.0713 1.00216 1.60994 1.30605 1.30605C1.60994 1.00216 2.0713 0.79077 2.84099 0.66293C3.61416 0.534512 4.63407 0.5 6 0.5C7.36593 0.5 8.38584 0.534512 9.15901 0.66293C9.9287 0.79077 10.3901 1.00216 10.6939 1.30605C10.9978 1.60994 11.2092 2.0713 11.3371 2.84099C11.4655 3.61416 11.5 4.63407 11.5 6C11.5 7.36593 11.4655 8.38584 11.3371 9.15901C11.2092 9.9287 10.9978 10.3901 10.6939 10.6939C10.3901 10.9978 9.9287 11.2092 9.15901 11.3371C8.38584 11.4655 7.36593 11.5 6 11.5C4.63407 11.5 3.61416 11.4655 2.84099 11.3371C2.0713 11.2092 1.60994 10.9978 1.30605 10.6939C1.00216 10.3901 0.79077 9.9287 0.66293 9.15901C0.534512 8.38584 0.5 7.36593 0.5 6Z"
              stroke="currentColor"
            />
            <path
              d="M4 7.1L4.92308 8L8 5"
              stroke="currentColor"
              strokeWidth="1.33333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      default:
        return (
          <svg
            width="13.5"
            height="13.5"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.5 6C0.5 4.63407 0.534512 3.61416 0.66293 2.84099C0.79077 2.0713 1.00216 1.60994 1.30605 1.30605C1.60994 1.00216 2.0713 0.79077 2.84099 0.66293C3.61416 0.534512 4.63407 0.5 6 0.5C7.36593 0.5 8.38584 0.534512 9.15901 0.66293C9.9287 0.79077 10.3901 1.00216 10.6939 1.30605C10.9978 1.60994 11.2092 2.0713 11.3371 2.84099C11.4655 3.61416 11.5 4.63407 11.5 6C11.5 7.36593 11.4655 8.38584 11.3371 9.15901C11.2092 9.9287 10.9978 10.3901 10.6939 10.6939C10.3901 10.9978 9.9287 11.2092 9.15901 11.3371C8.38584 11.4655 7.36593 11.5 6 11.5C4.63407 11.5 3.61416 11.4655 2.84099 11.3371C2.0713 11.2092 1.60994 10.9978 1.30605 10.6939C1.00216 10.3901 0.79077 9.9287 0.66293 9.15901C0.534512 8.38584 0.5 7.36593 0.5 6Z"
              stroke="currentColor"
            />
          </svg>
        );
    }
  };
  return middleSvg();
};

export const RedoIcon: React.FC<props> = ({ size = 20, ...props }) => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_138_7275)">
        <path
          d="M11.45 5.47001C11.48 6.05001 11.5 6.72001 11.5 7.50001C11.5 8.87001 11.47 9.89001 11.34 10.66C11.21 11.43 11 11.89 10.7 12.19C10.4 12.49 9.93002 12.71 9.17002 12.83C8.40002 12.96 7.38002 12.99 6.01002 12.99C4.64002 12.99 3.62002 12.96 2.85002 12.83C2.08002 12.7 1.62002 12.49 1.32002 12.19C1.02002 11.89 0.80002 11.42 0.68002 10.66C0.55002 9.89001 0.52002 8.87001 0.52002 7.50001C0.52002 6.13001 0.55002 5.11001 0.68002 4.34001C0.81002 3.57001 1.02002 3.11001 1.32002 2.81001C1.62002 2.51001 2.09002 2.29001 2.85002 2.17001C3.62002 2.04001 4.64002 2.01001 6.01002 2.01001C7.38002 2.01001 8.40002 2.04001 9.17002 2.17001C9.94002 2.30001 10.4 2.51001 10.7 2.81001"
          stroke="#B1B1B1"
          strokeLinecap="round"
          strokeLinejoin="bevel"
        />
        <path
          d="M9 0.5L11 2.5L9 4.5"
          stroke="#B1B1B1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_138_7275">
          <rect width="12" height="13.5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
